import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '../hooks/auth';
import DefaultLayout from '../pages/_layouts/default';
import LoggedLayout from '../pages/_layouts/logged';

const propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  privateRoute: PropTypes.string,
  loginRoute: PropTypes.bool,
  path: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  raw: PropTypes.bool,
  isAuthPage: PropTypes.bool,
};

const defaultProps = {
  privateRoute: null,
  loginRoute: false,
  exact: false,
  raw: false,
  isAuthPage: false,
};

const RouteWrapper = ({
  component: Component,
  privateRoute,
  loginRoute,
  path,
  exact,
  isAuthPage,
  raw,
}) => {
  const { isLoggedIn, userType } = useAuth();

  if (raw) {
    return (
      <Route
        path={path}
        exact={exact}
        render={props => <Component {...props} />}
      />
    );
  }

  if (isLoggedIn === null) {
    return null;
  }

  if (isLoggedIn && isAuthPage) {
    return <Redirect to="/" />;
  }

  if (loginRoute) {
    return <Route path={path} exact={exact} component={Component} />;
  }

  if (!privateRoute) {
    return (
      <Route
        path={path}
        exact={exact}
        render={props => (
          <DefaultLayout>
            <Component {...props} />
          </DefaultLayout>
        )}
      />
    );
  }

  if (!isLoggedIn) {
    return <Redirect to="/" />;
  }

  if (privateRoute === 'designer' && userType === 'cutter') {
    return <Redirect to="/" />;
  }

  return (
    <Route
      path={path}
      exact={exact}
      render={props => (
        <LoggedLayout type={privateRoute}>
          <Component {...props} />
        </LoggedLayout>
      )}
    />
  );
};

RouteWrapper.propTypes = propTypes;
RouteWrapper.defaultProps = defaultProps;

export default RouteWrapper;
